import { render, staticRenderFns } from "./RELegacyGrid.vue?vue&type=template&id=9d22e996&scoped=true&lang=html&"
import script from "./RELegacyGrid.vue?vue&type=script&lang=js&"
export * from "./RELegacyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d22e996",
  null
  
)

export default component.exports